import * as React from 'react';

// HORO-10703: crown glyph for the "Veda Plans" sidebar row. Same shape as
// subscriptionIcons/CrownIcon so premium keeps one symbol across the app,
// redrawn on the menu's 20x20 / white / 1.3 grid instead of that icon's
// 24x25 / #BEBDE0 / 2 — it has no viewBox, so it cannot simply be resized.
const PlansIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
        <path
            stroke="#FFFFFF"
            strokeWidth={1.3}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M2.6 5.2l2.6 7.6h9.6l2.6-7.6-4.2 4.8-3.2-5.4-3.2 5.4z"
        />
        <path stroke="#FFFFFF" strokeWidth={1.3} strokeLinecap="round" d="M5.4 15.4h9.2" />
    </svg>
);

export default PlansIcon;
